import edApi from "@/public/utils/edApi";
const $edApi = edApi();

export const state = () => ({
    allIsRead: false,
    NotifyMsgArr: [],
    showUserNotifyMsg: false,
    hasNewMsg: false,
});

const mutations = {
    setState(state, obj) {
        state[obj.type] = obj.data;
    },
};

const actions = {
    setIsRead({ state, dispatch }, payload) {
        let { id, token } = payload;
        return $edApi.setIsRead(payload).then((e) => {
            // console.log('设置已读')
            dispatch("checkNewMsg", { id, token });
            state.NotifyMsgArr.forEach((item) => {
                if (item.id == payload.ids || !!payload.all) {
                    item.is_read = true;
                }
            });
            dispatch("isAllIsRead");
        });
    },
    getNotifiedMsg({ commit, dispatch }, payload) {
        // console.log('更新用户通知信息')
        return $edApi.getNotifiedMsg(payload).then((e) => {
            commit("setState", {
                type: "NotifyMsgArr",
                data: e.data.notify,
            });
            dispatch("isAllIsRead");
        });
    },
    isAllIsRead({ state, commit }) {
        let unReadList = state.NotifyMsgArr.filter((v, k) => {
            return v.is_read == 0;
        });
        let ids = unReadList.map((v) => v.id);
        let allIsRead = false;
        if (ids.length > 0) {
            allIsRead = false;
        } else {
            allIsRead = true;
        }
        commit("setState", {
            type: "allIsRead",
            data: allIsRead,
        });
    },
    checkNewMsg({ commit }, payload) {
        // console.log('检查是否有未读信息');
        return $edApi.checkNewMsg(payload).then((e) => {
            if (e.status == "success") {
                commit("setState", {
                    type: "hasNewMsg",
                    data: true,
                });
            } else {
                commit("setState", {
                    type: "hasNewMsg",
                    data: false,
                });
            }
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
